import { t } from '../../i18n.es.js';
import { Button } from '@teko/ds-desktop';
import { ShareFilled } from '@teko/ds-icon';
import React from 'react';
import { isBrowserShareAvailable, isTerraShareAvailable, share } from '../../helpers/browser-share.es.js';

const GroupBuyShareButton = ({
  title,
  text,
  url
}) => {
  const isShareAvailable = isBrowserShareAvailable() || isTerraShareAvailable();
  const onShare = () => {
    share(title, text, url);
  };
  return isShareAvailable ? /* @__PURE__ */ React.createElement(Button, {
    onClick: onShare,
    prefix: /* @__PURE__ */ React.createElement(ShareFilled, {
      size: 20,
      color: "#fff"
    }),
    paddingLeft: "s16"
  }, t("K\xEAu g\u1ECDi mua chung")) : null;
};

export { GroupBuyShareButton };
